"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRolLinkUnsafe = exports.isRolLink = exports.rolLinkUseableDef = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const schemaVersions_1 = require("../schemaVersions");
const ArticleSpecs_1 = require("../ArticleSpecs");
exports.rolLinkUseableDef = {
    parent: schemaVersions_1.linkLatestUseableDef,
    validation: {
        // todo LinkType instead of ArticleSpecs [EKE-11146]
        ArticleSpecs: (type) => Boolean(type === null || type === void 0 ? void 0 : type.includes(ArticleSpecs_1.ArticleSpecs.rolEchainRolLink)),
        K2: echain_shared_quantities_1.isQuantityJson,
        Teilung: echain_shared_quantities_1.isQuantityJson,
        Innenhoehe: echain_shared_quantities_1.isQuantityJson,
        Innenbreite: echain_shared_quantities_1.isQuantityJson,
        IndexBreite: true,
        IndexBiegeradius: true,
        Aussenhoehe: echain_shared_quantities_1.isQuantityJson,
        Aussenbreite: echain_shared_quantities_1.isQuantityJson,
        Id: true,
        Bezeichnung: true,
    },
    unsafeValidation: {
        ArticleSpecs: (specs) => Boolean(specs === null || specs === void 0 ? void 0 : specs.includes(ArticleSpecs_1.ArticleSpecs.rolEchainRolLink)),
    },
};
exports.isRolLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolLinkUseableDef);
exports.isRolLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolLinkUseableDef);
//# sourceMappingURL=RolLink.js.map